import { executeRequest, Request } from '@jfs/network'
import { RootStore } from '../../../data/store'
import { getNetworkResponseError, isStatusCreatedOK } from '../../../util/utill'
import { APIEndPoints } from '../../APIEndPoints'
import { sitConfig } from '../../config'
import { sendEventApi } from '../../sendEvent'

const responseParser = (data: any) => {
  if (!data) {
    throw { message: 'Server returned no data. Please try again.', code: 'EMPTY_RESPONSE' };
  }
  if (typeof data === 'string' && data.includes('<html>')) {
    throw { message: 'Internal Server Error (500). Please try later.', code: 'SERVER_ERROR_HTML' };
  }
  if (isStatusCreatedOK(data)) {
    // console.log('NETWORK PARSER: Registration successful (isStatusOK is true).')
    return data
  } else {
    // console.error('NETWORK PARSER: Throwing true failure:', data?.data)
    throw getNetworkResponseError(data?.data || data || { message: 'Registration failed' });
  }
}

export const registerUserBCApi = (
  tokens: any,
  body: { authorizationCode: string; mobileNumber: string; firstName: string; middleName?: string; lastName: string },
) => {
  let config = sitConfig(tokens) as any
  const baseUserAccessToken = config.headers['x-user-access-token']
  const baseUserIdToken = config.headers['x-userid-token'] // Use the RootStore value, OR fall back to the token that came from the 'tokens' argument
  config.headers['x-user-access-token'] = RootStore?.bcAppInfo?.userAccessToken || baseUserAccessToken
  config.headers['x-userid-token'] = RootStore?.bcAppInfo?.userIdentifier || baseUserIdToken
  let asasas = RootStore.agent.agentInfo
  // console.log(`Agent Information ${asasas}`)
  const requestBody = {
    authorizationCode: body.authorizationCode,
    user: {
      mobile: {
        mobileNumber: body.mobileNumber,
        countryCode: '91',
      },
      name: {
        firstName: body.firstName,
        middleName: body.middleName || '',
        lastName: body.lastName,
      },
    },
  }

  // console.log('API BODY (registerUserBCApi):', JSON.stringify(requestBody, null, 2))

  const request: Request<{}> = {
    apiPath: APIEndPoints.registerUser,
    method: 'POST',
    config: config,
    body: requestBody,
  }
  sendEventApi(tokens, request, {
    status: 'INITIATED',
  })
  return executeRequest(request)
    .then((data) => {
      // console.log(data, 'Akanksha')
      // console.log('NETWORK RAW RESPONSE (registerUserBCApi):', data)
      return responseParser(data)
    })
    .then((response) => {
      // console.log('NETWORK PARSED SUCCESS (registerUserBCApi):', response)
      sendEventApi(tokens, request, {
        status: 'SUCCESS',
      })
      return response
    })
    .catch((err) => {
      // console.error('NETWORK CATCH (registerUserBCApi): Failed with error:', err)
      sendEventApi(tokens, request, {
        status: 'FAILED',
        errorDescription: err,
      })
      throw err
    })
}
